import request from '@/utils/Request'

export type VerifyOtpCodeRequestParams = {
  email: string,
  code: string,
  device_uuid: string,
  is_forgot_password?: boolean,
  dont_set_verified?: boolean
}

export type VerifyOtpCodeResponse = {
  is_logged: boolean
  access_token: string

  user: {
    id: number;
    is_registered: boolean;
    is_updated_profile: boolean;
  }
}

export async function verifyOtpCode(params: VerifyOtpCodeRequestParams) {
  return await request.post<VerifyOtpCodeResponse>('/verify-otp-code', params)
}
